// Put your application javascript here
// Prevent closing from click inside dropdown
$(document).on('click', '.dropdown-menu', function (e) {
  e.stopPropagation();
});

$(document).ready(function(e){
  if ($(window).width() < 992) {
    $('.dropdown-item').click(function(e){
      if($(this).next('.submenu').length){
        console.log($(this));
        e.stopPropagation();
        e.preventDefault();
        $(this).next('.submenu').toggle();
      }
      $('.dropdown').on('hide.bs.dropdown', function () {
      	$(this).find('.submenu').hide();
      })
  	});
  }
});

// make it as accordion for smaller screens

// Open the full screen search box
function openSearch() {
  document.getElementById("myOverlay").style.display = "block";
}

// Close the full screen search box
function closeSearch() {
  document.getElementById("myOverlay").style.display = "none";
}

